exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message[data-v-15d232e8] {\n  background: #ffffff;\n  max-height: calc(100vh - 300px);\n  overflow: auto;\n  padding: 8px;\n}\n.message .comment[data-v-15d232e8] {\n    text-align: left;\n    color: grey;\n    font-size: 13px;\n}\n.message[data-v-15d232e8]::-webkit-scrollbar {\n  width: 6px;\n  height: 0px;\n  visibility: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15d232e8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/chatbot/scenarioEdit/ScenarioEditApply.vue
// module id = qF9e
// module chunks = 0